/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * InternalServerError.ts
 */

import APIError from "./APIError";

export default class InternalServerError extends APIError {
    constructor(message: string) {
        super("Erreur du serveur", 500, message);
    }
}